"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var colors_1 = require("../colors");

var typography_1 = require("../typography");

var core_1 = require("@emotion/core");

var getOffsetInPalette_1 = require("../colors/utils/getOffsetInPalette");

var tinycolor2_1 = tslib_1.__importDefault(require("tinycolor2"));

var react_1 = tslib_1.__importDefault(require("react"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Loaders_1 = require("../Loaders");

function assertUnreachable(value) {
  throw new TypeError("Unreachable value reached " + value);
}

var defaultColor = colors_1.colors.silver.light;

function getTextColor(_a) {
  var color = _a.color,
      feel = _a.feel,
      theme = _a.theme,
      mode = _a.mode;

  if (color === colors_1.colors.white) {
    return colors_1.colors.grey.darker;
  }

  switch (feel) {
    case "raised":
      return !mode ? tinycolor2_1["default"].mostReadable(getHoverBackgroundColor({
        color: color,
        feel: feel,
        theme: theme
      }), [colors_1.colors.white, colors_1.colors.grey.darker], {
        level: "AA",
        size: "small"
      }).toString() : undefined;

    case "flat":
      if (color === defaultColor) {
        return theme === "dark" ? colors_1.colors.grey.light : colors_1.colors.grey.darker;
      }

      if (theme === "dark" && (!mode || mode === ":focus")) {
        return getOffsetInPalette_1.getOffsetInPalette(1, "lighter", color);
      }

      return color;

    default:
      throw assertUnreachable(feel);
  }
}

function getHeight(_a) {
  var size = _a.size;

  switch (size) {
    case "small":
      return 28;

    case "default":
      return 36;

    case "large":
      return 42;

    default:
      throw assertUnreachable(size);
  }
}

function getHoverBackgroundColor(_a) {
  var color = _a.color,
      feel = _a.feel,
      theme = _a.theme;

  if (color === colors_1.colors.white) {
    return colors_1.colors.silver.light;
  }

  switch (feel) {
    case "flat":
      if (color === defaultColor) {
        return theme === "light" ? colors_1.colors.silver.light : colors_1.colors.grey.dark;
      }

      return getOffsetInPalette_1.getOffsetInPalette(Infinity, "lighter", color);

    case "raised":
      return getOffsetInPalette_1.getOffsetInPalette(1, "darker", color);

    default:
      throw assertUnreachable(feel);
  }
}

exports.Button = function (_a) {
  var _b = _a.as,
      as = _b === void 0 ? react_1["default"].createElement("button", null) : _b,
      children = _a.children,
      _c = _a.color,
      color = _c === void 0 ? defaultColor : _c,
      _d = _a.disabled,
      disabledProps = _d === void 0 ? false : _d,
      variant = _a.variant,
      _e = _a.feel,
      feel = _e === void 0 ? "raised" : _e,
      iconProp = _a.icon,
      loading = _a.loading,
      _f = _a.size,
      size = _f === void 0 ? "default" : _f,
      _g = _a.theme,
      theme = _g === void 0 ? "light" : _g,
      otherProps = tslib_1.__rest(_a, ["as", "children", "color", "disabled", "variant", "feel", "icon", "loading", "size", "theme"]);

  return react_1["default"].createElement(core_1.ClassNames, null, function (_a) {
    var cx = _a.cx,
        css = _a.css;
    var disabled = loading || (as.props.disabled != null ? as.props.disabled : disabledProps);
    var icon = loading ? react_1["default"].createElement(Loaders_1.LoadingSpinner, {
      size: "2xsmall",
      theme: theme === "light" ? "grayscale" : "dark"
    }) : iconProp;
    var iconSize = size === "small" ? 12 : size === "large" ? 24 : 16;
    var iconOnly = !children;

    if (variant === "fab") {
      if (!icon) {
        throw new TypeError("FAB buttons are required to have an `icon`");
      } else if (children) {
        throw new TypeError("FAB buttons cannot have children, only an `icon`");
      }
    }

    var propsToPass = tslib_1.__assign({}, otherProps, {
      className: classnames_1["default"]("className" in otherProps && otherProps.className, cx(css([tslib_1.__assign({
        "&[disabled], &[disabled]:hover": {
          backgroundColor: feel === "flat" ? "transparent" : theme === "light" ? colors_1.colors.silver.light : colors_1.colors.grey.dark,
          boxShadow: "none",
          color: feel === "flat" && theme === "dark" ? colors_1.colors.grey.dark : colors_1.colors.grey.light
        },
        backgroundColor: color === colors_1.colors.white ? colors_1.colors.white : feel === "raised" ? color : "transparent",
        borderRadius: variant === "fab" ? "100%" : 4,
        borderWidth: 0
      }, feel !== "flat" && {
        boxShadow: theme === "light" ? "0 1px 4px 0 rgba(18, 21, 26, 0.04), inset 0 0 0 1px rgba(18, 21, 26, 0.2), inset 0 -1px 0 0 rgba(18, 21, 26, 0.05)" : "0 0 0 1px rgba(18, 21, 26, 0.2), 0 1px 4px 0 rgba(18, 21, 26, 0.08), 0 1px 0 0 rgba(18, 21, 26, 0.05)"
      }, {
        color: getTextColor({
          color: color,
          feel: feel,
          theme: theme
        }),
        cursor: loading || disabled ? "default" : "pointer",
        display: "inline-flex",
        justifyContent: "center",
        height: getHeight({
          size: size
        }),
        minWidth: iconOnly ? size === "small" ? 28 : size === "large" ? 42 : 36 : size === "small" ? 76 : size === "large" ? 112 : 100,
        padding: "0 " + (iconOnly ? 0 : 12) + "px"
      }, size === "small" ? typography_1.base.small : size === "large" ? typography_1.base.large : typography_1.base.base, {
        fontWeight: 600,
        outline: 0,
        textDecoration: "none",
        whiteSpace: "nowrap"
      }), !disabled && {
        ":hover, &[data-force-hover-state]": tslib_1.__assign({
          backgroundColor: getHoverBackgroundColor({
            color: color,
            feel: feel,
            theme: theme
          }),
          color: getTextColor({
            color: color,
            feel: feel,
            theme: theme,
            mode: ":hover"
          })
        }, feel !== "flat" && {
          boxShadow: theme === "light" ? "0 5px 10px 0 rgba(18, 21, 26, 0.08), inset 0 0 0 1px rgba(18, 21, 26, 0.2), inset 0 -1px 0 0 rgba(18, 21, 26, 0.05)" : "0 0 0 1px rgba(18, 21, 26, 0.2), 0 5px 10px 0 rgba(18, 21, 26, 0.12), 0 1px 0 0 rgba(18, 21, 26, 0.05)"
        }),
        ":focus, &[data-force-focus-state]": tslib_1.__assign({}, feel === "flat" && {
          backgroundColor: theme === "light" ? colors_1.colors.white : "#000",
          color: theme === "light" ? colors_1.colors.blue.base : colors_1.colors.blue.light
        }, {
          boxShadow: "0 1px 4px 0 rgba(18, 21, 26, 0.08), 0 0 0 2px " + (theme === "light" || color === defaultColor || color === colors_1.colors.white ? "#bbdbff" : getOffsetInPalette_1.getOffsetInPalette(Infinity, "lighter", color)) + ", inset 0 0 0 1px " + (color === defaultColor || color === colors_1.colors.white ? "#2075d6" : getOffsetInPalette_1.getOffsetInPalette(1, "darker", color)) + ", inset 0 -1px 0 0 rgba(18, 21, 26, 0.05)"
        }),
        "&:active, &[data-force-active-state]": tslib_1.__assign({}, getTextColor({
          color: color,
          feel: feel,
          theme: theme,
          mode: ":hover"
        }) && {
          color: getTextColor({
            color: color,
            feel: feel,
            theme: theme,
            mode: ":active"
          })
        }, {
          backgroundColor: color === colors_1.colors.white ? colors_1.colors.white : feel === "raised" ? color : color === defaultColor ? theme === "dark" ? colors_1.colors.grey.darker : colors_1.colors.silver.base : getOffsetInPalette_1.getOffsetInPalette(2, "lighter", color),
          boxShadow: feel !== "flat" ? theme === "light" ? "inset 0 0 0 1px rgba(18, 21, 26, 0.2), inset 0 -1px 0 0 rgba(18, 21, 26, 0.05), inset 0 2px 2px 0 rgba(18, 21, 26, 0.12)" : "0 0 0 1px rgba(18, 21, 26, 0.2), 0 1px 4px 0 rgba(18, 21, 26, 0.08), 0 -1px 0 0 rgba(18, 21, 26, 0.16), inset 0 1px 2px 0 rgba(18, 21, 26, 0.42)" : "none",
          outline: "0"
        })
      }]))),
      disabled: disabled,
      onClick: function onClick(event) {
        if (disabled) return event.preventDefault();

        if (otherProps.onClick) {
          otherProps.onClick(event);
        }

        if (as.props.onClick) {
          as.props.onClick(Event);
        }

        event.currentTarget.blur();
      },
      children: react_1["default"].createElement("div", {
        className: cx(css({
          alignItems: "center",
          display: "flex",
          justifyContent: "center"
        }))
      }, icon && react_1["default"].createElement("span", {
        className: cx(css({
          alignItems: "center",
          display: "inline-flex",
          height: iconSize,
          justifyContent: "center",
          margin: iconOnly ? 0 : "0 4px 0",
          width: iconSize
        }))
      }, icon), children)
    });

    return react_1["default"].cloneElement(as, tslib_1.__assign({}, propsToPass, {
      className: classnames_1["default"](propsToPass.className, as.props.className, as.props.css ? css(as.props.css.styles) : null)
    }));
  });
};